export const getAppointmentAnalysesData = state => state.appointmentAnalyses.all;
export const getAppointmentAnalysisData = state => state.appointmentAnalyses.appointmentAnalysis;
export const appointmentAnalysesIsFetching = state => state.appointmentAnalyses.loading.all;
export const appointmentAnalysisIsFetching = state => state.appointmentAnalyses.loading.appointmentAnalysis;
